
import './filterDateInput.css';
import React, { useState, useEffect } from 'react'

function FilterDateInput({ placeholder, item, setItem }) {
    const [calendarActive, setCalendarActive] = useState(false);
    const [labelActive, setLabelActive] = useState(false);

    const calendarActiveChangeHandler = () => {
        setCalendarActive(prev => !prev);
    }
    /*** Calendar Part ***/
    const [monthPicker, setMonthPicker] = useState(() => {
        let currDate = new Date();
        return currDate.getMonth();
    });
    const [yearPicker, setYearPicker] = useState(() => {
        let currDate = new Date();
        return currDate.getFullYear();
    });
    const [febDays, setFebDays] = useState(28);
    const [monthShow, setMonthShow] = useState(false);
    const month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const days_of_month = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    let currDate = new Date();
    let first_day = new Date(yearPicker, monthPicker, 1);

    useEffect(() => {
        isLeapYear(yearPicker) ? setFebDays(29) : setFebDays(28)
    }, [yearPicker])

    const isLeapYear = (year) => {
        return (year % 100 === 0 && year % 400 === 0) || (year % 100 !== 0 && year % 400 !== 0 && year % 4 === 0);
    }
    const yearHandle = (type) => {
        if (type === 'add') {
            setYearPicker(prev => prev + 1)
        } else {
            setYearPicker(prev => prev - 1)
        }
    }
    const monthListHandler = (index) => {
        setMonthPicker(index);
        setMonthShow(false);
    }
    const getCalendarDate = (dd) => {
        setLabelActive(true);
        setItem(`${yearPicker}-${monthPicker + 1}-${dd}`);
        setCalendarActive(false);
    }
    const removeCalendarDate = () => {
        setLabelActive(false);
        setItem('');
        setCalendarActive(false);
    }


    return (
        <div className="filter-input">
            <input type="text" value={item} readOnly />
            <label className={labelActive ? 'active' : ''}>{placeholder}</label>
            <span id='calendar-icon' className="material-symbols-rounded" onClick={calendarActiveChangeHandler}>calendar_month</span>

            <div className={calendarActive ? "calendar-global active" : "calendar-global"}>
                <div className="calendar">
                    <span id="close" onClick={()=>setCalendarActive(false)} className="material-symbols-rounded">close</span>
                    {/* <!-- Calendar header --> */}
                    <div className="calendar-header">
                        <span className="month-picker" onClick={() => setMonthShow(true)}>{month_names[monthPicker]}</span>
                        <div className="year-picker">
                            <span className="year-change" id="prev-year" onClick={() => yearHandle('remove')}>
                                <span className="material-symbols-rounded">chevron_left</span>
                            </span>
                            <span id="year">{yearPicker}</span>
                            <span className="year-change" id="next-year" onClick={() => yearHandle('add')}>
                                <span className="material-symbols-rounded">chevron_right</span>
                            </span>
                        </div>
                    </div>
                    {/* <!-- End Calendar header --> */}


                    {/* <!-- Calendar body --> */}
                    <div className="calendar-body">
                        <div className="calendar-week-day">
                            <div>Sun</div>
                            <div>Mon</div>
                            <div>Tue</div>
                            <div>Wed</div>
                            <div>Thu</div>
                            <div>Fri</div>
                            <div>Sat</div>
                        </div>

                        <div className="calendar-days">
                            {
                                [...Array(days_of_month[monthPicker] + first_day.getDay()).keys()].map((x) => (
                                    x >= first_day.getDay() ? (
                                        <div key={x} onClick={() => getCalendarDate(x - first_day.getDay() + 1)} className={(x - first_day.getDay() + 1 === currDate.getDate() && yearPicker === currDate.getFullYear() && monthPicker === currDate.getMonth()) ? 'curr-date calendar-day-hover' : 'calendar-day-hover'}   >
                                            {x - first_day.getDay() + 1}
                                        </div>
                                    ) : (
                                        <div key={x}></div>
                                    )

                                ))
                            }
                        </div>
                    </div>
                    {/* <!-- End Calendar body --> */}

                    {/* <!-- Calendar footer --> */}
                    <div className="calendar-footer">
                        <span onClick={removeCalendarDate}>Clear</span>
                    </div>
                    {/* <!-- End Calendar footer --> */}


                    <div className={monthShow ? "month-list show" : "month-list"}>
                        {
                            month_names.map((item, index) => (
                                <div key={index} onClick={() => monthListHandler(index)}>
                                    <div>{item}</div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>


        </div>
    )
}

export default FilterDateInput
